import CoursesRouter from '@/components/pages/course/index.vue';
import CourseImport from '@/components/pages/course/CourseImport.vue';

export default {
  path: '/courses',
  name: 'CoursesRouter',
  component: CoursesRouter,
  children: [
    {
      path: '/courses/import',
      component: CourseImport,
      name: 'CourseImport',
      meta: {
        acceptRoles: ['admin'],
      },
    },
  ],
}
